import { render, staticRenderFns } from "./VoucherDetails.vue?vue&type=template&id=09657b3d&scoped=true&"
import script from "./VoucherDetails.vue?vue&type=script&lang=js&"
export * from "./VoucherDetails.vue?vue&type=script&lang=js&"
import style0 from "./VoucherDetails.vue?vue&type=style&index=0&id=09657b3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09657b3d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09657b3d')) {
      api.createRecord('09657b3d', component.options)
    } else {
      api.reload('09657b3d', component.options)
    }
    module.hot.accept("./VoucherDetails.vue?vue&type=template&id=09657b3d&scoped=true&", function () {
      api.rerender('09657b3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Invoices/NewInvoice/VoucherDetails.vue"
export default component.exports